(function () {
	'use strict';
	var $ = window.jQuery;

	function Szn(options) {
		if (!options) {
			throw new Error('No options passed to Szn constructor');
		}

		this.options = $.extend({}, Szn.defaults, options);

		if ($('.szn_page').length) {
			this.initStickyHeader();
			this.initMobileHeaderNav();
			this.initAnchorLinks();
		}
	}

	Szn.prototype.initStickyHeader = function () {
		var $headerSelector = $(this.options.headerContainer);

		if ($headerSelector.length) {
			// Sticky Header
			new window.Waypoint.Sticky({
				element: $headerSelector[0],
				stuckClass: 'fixed',
			});
		}
	};

	Szn.prototype.initMobileHeaderNav = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb');

		$mobileHamburger.click(function (e) {
			e.preventDefault();

			$(this).toggleClass('open');

			if ($headerNavSelector.hasClass('opened')) {
				$bodySelector.removeClass('mobile-menu-opened');
				$headerNavSelector.removeClass('opened');
				$('.sub-menu').removeClass('opened').fadeOut(300);
				$('li.has-dropdown > a').removeClass('active');
			} else {
				$bodySelector.addClass('mobile-menu-opened');
				$headerNavSelector.addClass('opened');
				setTimeout(function () {
					$headerNavSelector.find('> ul > li.has-dropdown > a').first().trigger('click');
				},300)
			}
		});

		$(window).resize(function () {
			$mobileHamburger.removeClass('open');
			$bodySelector.removeClass('mobile-menu-opened');
			$headerNavSelector.removeClass('opened');
			$('li.has-dropdown > a').removeClass('active');
		});
	};

	Szn.prototype.initAnchorLinks = function () {
		var $headerNavSelector = $(this.options.headerNavSelector),
			$bodySelector = $('html, body'),
			$mobileHamburger = $headerNavSelector.find('.hamb');

		$('a[href*="#"]:not([href="#"])').click(function() {
			if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
				var target = $(this.hash),
					offset = 85;
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if ($(window).width() < 1200) {
					offset = 70;
				}
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top - offset,
					}, 1000);

					$mobileHamburger.removeClass('open');
					$bodySelector.removeClass('mobile-menu-opened');
					$headerNavSelector.removeClass('opened');
					$('li.has-dropdown > a').removeClass('active');
					return false;
				}
			}
		});
	};

	Szn.defaults = {
		headerNavSelector: '.szn_page .header__nav',
		headerContainer: '.szn_page .header',
	};

	window.Szn = Szn;
}());
